<info-modal [title]="title" (onOk)="ok()">
	<style>
		.limit-width {
			max-width: 300px;
		}
	</style>
	
	<div class="table-responsive-xl" style="overflow-x: scroll;">
		<table class="table table-bordered">
			<thead>
				<tr>
					<th>
						Path
					</th>
					
					<th>
						SQL
					</th>
				</tr>
			</thead>
			
			<tbody>
				<tr *ngFor="let query of queries">
					<td>
						{{ query.path }}
					</td>
					
					<td>
						<span class="button-download-link float-right" (click)="copyToClipboard(query.sql)">
							<i class="fas fa-copy"></i>
							Copy!
						</span>
						
						<div class="limit-width">
							<pre innerHTML="{{query.formatedSql}}"></pre>
						</div>
						
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</info-modal>
